import { SeverityTag } from "@/molecules/SeverityTag"

import type { Severity } from "@/domain/vulnerability"
import type { TFunction } from "@/hooks/useTranslation"

export const SeverityCell = (t: TFunction) =>
  function SeverityCell(severity: Severity, { cvss }: { cvss: number }) {
    return <SeverityTag t={t} severity={severity} cvss={cvss} />
  }
